import StepShell from '../StepShell';
import { colors, layout } from '../styles';
import usePreEmploymentDraft from './preEmployment/usePreEmploymentDraft';
import useSaveLaterHandler from './preEmployment/useSaveLaterHandler';
import { formatPhone } from '../utils/numberValidation';
import { BaseStepProps } from './BaseStepProps';

const PreEmploymentEmergencyStep = ({
  step,
  stepIndex,
  totalSteps,
  completedSteps,
  token,
  tokenData,
  applicationDraft,
  onBack,
  onPrevious,
  onNext,
  onSaveLater,
}: BaseStepProps) => {
  const { formData, updateForm, saveAsDraft } = usePreEmploymentDraft(token, applicationDraft);
  const { handleSaveLater } = useSaveLaterHandler({
    saveAsDraft: () => saveAsDraft({ token, userId: tokenData.userId, userName: tokenData.userName }),
    onSaveLater,
  });

  const hasAtLeastOnePhone = !!formData.emergencyPhoneH || !!formData.emergencyPhoneC || !!formData.emergencyPhoneOther;
  const canSubmit = !!formData.emergencyName && !!formData.emergencyRelationship && hasAtLeastOnePhone;

  return (
    <StepShell
      stepNumber={stepIndex + 1}
      totalSteps={totalSteps}
      completedSteps={completedSteps}
      title={step.title}
      onBack={onBack}
      onPrevious={onPrevious}
      onSaveLater={handleSaveLater}
      onNext={onNext}
      nextLabel="Next"
      nextDisabled={!canSubmit}
    >
      <h3 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Emergency Contact</h3>
      <p style={{ color: colors.muted, fontSize: 14, marginTop: 6 }}>
        Provide a contact we can reach in case of an emergency.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div>
          <label style={layout.label}>Full Name *</label>
          <input
            type="text"
            value={formData.emergencyName}
            onChange={(e) => updateForm({ emergencyName: e.target.value })}
            style={layout.input}
          />
        </div>
        <div>
          <label style={layout.label}>Relationship *</label>
          <input
            type="text"
            value={formData.emergencyRelationship}
            onChange={(e) => updateForm({ emergencyRelationship: e.target.value })}
            placeholder="e.g., Spouse, Parent, Sibling"
            style={layout.input}
          />
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={layout.label}>Address</label>
        <input
          type="text"
          value={formData.emergencyAddress}
          onChange={(e) => updateForm({ emergencyAddress: e.target.value })}
          style={layout.input}
        />
      </div>

      <p style={{ color: colors.muted, fontSize: 13, marginTop: 0, marginBottom: 8 }}>
        At least one phone number is required.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div>
          <label style={layout.label}>Home Phone</label>
          <input
            type="tel"
            value={formData.emergencyPhoneH}
            onChange={(e) => updateForm({ emergencyPhoneH: formatPhone(e.target.value) })}
            placeholder="(555) 123-4567"
            style={layout.input}
          />
        </div>
        <div>
          <label style={layout.label}>Cell Phone</label>
          <input
            type="tel"
            value={formData.emergencyPhoneC}
            onChange={(e) => updateForm({ emergencyPhoneC: formatPhone(e.target.value) })}
            placeholder="(555) 123-4567"
            style={layout.input}
          />
        </div>
        <div>
          <label style={layout.label}>Other Phone</label>
          <input
            type="tel"
            value={formData.emergencyPhoneOther}
            onChange={(e) => updateForm({ emergencyPhoneOther: formatPhone(e.target.value) })}
            placeholder="(555) 123-4567"
            style={layout.input}
          />
        </div>
      </div>
    </StepShell>
  );
};

export default PreEmploymentEmergencyStep;
